import React, { useState } from "react";
import { personnelApi } from "../../api/personnelApi";

const CONTRACT_TYPES = [
  { value: "PERMANENT", label: "A tempo indeterminato" },
  { value: "FIXED_TERM", label: "A tempo determinato" },
  { value: "SEASONAL", label: "Stagionale" },
  { value: "APPRENTICESHIP", label: "Apprendistato" },
  { value: "OTHER", label: "Altro" },
];

export default function EmployeeCreateModal({ show, onClose, onCreated }) {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    fiscalCode: "",
    address: "",
    matricola: "",
    // Anagrafica estesa
    birthDate: "",
    birthPlace: "",
    gender: "",
    levelCode: "",
    qualification: "",
    // Contratto
    contractType: "PERMANENT",
    contractStartDate: "",
    contractEndDate: "",
    // Ferie
    accruedDays: "",
    usedDays: "",
    // Permessi (gg disponibili/usati)
    permessiDays: "",
  });
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");
  const [creating, setCreating] = useState(false);

  if (!show) return null;

  async function create() {
    setErr("");
    setOk("");
    setCreating(true);
    try {
      const emp = await personnelApi.createEmployee({
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email || undefined,
        phone: form.phone || undefined,
        fiscalCode: form.fiscalCode || undefined,
        address: form.address || undefined,
        matricola: form.matricola || undefined,
         birthDate: form.birthDate || undefined,
         birthPlace: form.birthPlace || undefined,
         gender: form.gender || undefined,
         levelCode: form.levelCode || undefined,
         qualification: form.qualification || undefined,
      });
      const employeeId = emp?.id ?? emp?.data?.id;
      if (!employeeId) throw new Error("Dipendente non creato");

      // Contratto
      if (form.contractType && form.contractStartDate) {
        await personnelApi.createContract(employeeId, {
          type: form.contractType,
          startDate: form.contractStartDate,
          endDate: form.contractEndDate || undefined,
        });
      }

      // Ferie e permessi
      const accrued = parseFloat(form.accruedDays) || 0;
      const used = parseFloat(form.usedDays) || 0;
      const permessi = parseFloat(form.permessiDays) || 0;
      if (accrued > 0 || used > 0 || permessi > 0) {
        await personnelApi.upsertLeave(employeeId, {
          accruedDays: accrued,
          usedDays: used + permessi,
        });
      }

      setOk("Dipendente creato con contratto, ferie e permessi ✅");
      setForm({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        fiscalCode: "",
        address: "",
        matricola: "",
        birthDate: "",
        birthPlace: "",
        gender: "",
        levelCode: "",
        qualification: "",
        contractType: "PERMANENT",
        contractStartDate: "",
        contractEndDate: "",
        accruedDays: "",
        usedDays: "",
        permessiDays: "",
      });
      await onCreated?.();
    } catch (e) {
      setErr(String(e?.message || e));
    } finally {
      setCreating(false);
    }
  }

  return (
    <div className="modal d-block" tabIndex={-1} role="dialog" style={{ background: "rgba(0,0,0,0.35)" }}>
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Nuovo dipendente</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>

          <div className="modal-body">
            <div className="row g-2">
              <div className="col-md-6">
                <label className="form-label">Nome</label>
                <input className="form-control" value={form.firstName}
                  onChange={(e) => setForm({ ...form, firstName: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Cognome</label>
                <input className="form-control" value={form.lastName}
                  onChange={(e) => setForm({ ...form, lastName: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Email</label>
                <input className="form-control" value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Telefono</label>
                <input className="form-control" value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Codice Fiscale</label>
                <input className="form-control" value={form.fiscalCode}
                  onChange={(e) => setForm({ ...form, fiscalCode: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Indirizzo</label>
                <input className="form-control" value={form.address}
                  onChange={(e) => setForm({ ...form, address: e.target.value })}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Matricola</label>
                <input
                  className="form-control"
                  value={form.matricola}
                  onChange={(e) => setForm({ ...form, matricola: e.target.value })}
                  placeholder="Codice interno dipendente"
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Comune di nascita</label>
                <input
                  className="form-control"
                  value={form.birthPlace}
                  onChange={(e) => setForm({ ...form, birthPlace: e.target.value })}
                  placeholder="Comune (es. Verona)"
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Data di nascita</label>
                <input
                  type="date"
                  className="form-control"
                  value={form.birthDate}
                  onChange={(e) => setForm({ ...form, birthDate: e.target.value })}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Genere</label>
                <select
                  className="form-select"
                  value={form.gender}
                  onChange={(e) => setForm({ ...form, gender: e.target.value })}
                >
                  <option value="">—</option>
                  <option value="MALE">Maschio</option>
                  <option value="FEMALE">Femmina</option>
                  <option value="OTHER">Altro / Non specificato</option>
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">Codice livello</label>
                <input
                  className="form-control"
                  value={form.levelCode}
                  onChange={(e) => setForm({ ...form, levelCode: e.target.value })}
                  placeholder="Es. 4S, 5, 6"
                />
              </div>
              <div className="col-md-8">
                <label className="form-label">Qualifica</label>
                <input
                  className="form-control"
                  value={form.qualification}
                  onChange={(e) => setForm({ ...form, qualification: e.target.value })}
                  placeholder="Es. Cuoco, Cameriere, Responsabile di sala"
                />
              </div>
            </div>

            <hr className="my-3" />
            <h6 className="mb-2">Contratto</h6>
            <div className="row g-2">
              <div className="col-md-4">
                <label className="form-label">Tipo</label>
                <select className="form-select" value={form.contractType}
                  onChange={(e) => setForm({ ...form, contractType: e.target.value })}>
                  {CONTRACT_TYPES.map((t) => (
                    <option key={t.value} value={t.value}>{t.label}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">Data inizio</label>
                <input type="date" className="form-control" value={form.contractStartDate}
                  onChange={(e) => setForm({ ...form, contractStartDate: e.target.value })}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Data fine (opzionale)</label>
                <input type="date" className="form-control" value={form.contractEndDate}
                  onChange={(e) => setForm({ ...form, contractEndDate: e.target.value })}
                />
              </div>
            </div>

            <hr className="my-3" />
            <h6 className="mb-2">Ferie</h6>
            <div className="row g-2">
              <div className="col-md-4">
                <label className="form-label">Giorni maturati</label>
                <input type="number" min="0" step="0.5" className="form-control" placeholder="0"
                  value={form.accruedDays}
                  onChange={(e) => setForm({ ...form, accruedDays: e.target.value })}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Giorni usati (ferie)</label>
                <input type="number" min="0" step="0.5" className="form-control" placeholder="0"
                  value={form.usedDays}
                  onChange={(e) => setForm({ ...form, usedDays: e.target.value })}
                />
              </div>
            </div>

            <hr className="my-3" />
            <h6 className="mb-2">Permessi</h6>
            <div className="row g-2">
              <div className="col-md-4">
                <label className="form-label">Giorni permessi (usati)</label>
                <input type="number" min="0" step="0.5" className="form-control" placeholder="0"
                  value={form.permessiDays}
                  onChange={(e) => setForm({ ...form, permessiDays: e.target.value })}
                />
              </div>
            </div>

            {err ? <div className="alert alert-danger mt-3 mb-0">{err}</div> : null}
            {ok ? <div className="alert alert-success mt-3 mb-0">{ok}</div> : null}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
              Chiudi
            </button>
            <button type="button" className="btn btn-primary" onClick={create} disabled={creating}>
              {creating ? "Creazione…" : "Crea"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
